import { FC } from 'react'
import { createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from 'react-router-dom'

import MainLayout from '../layout/main-layout'
import { PrivateRouteWrapper } from '../private-route-wrapper'
import { DashboardPage } from '../pages/dashboard'
import { FormBuilderPage } from '../pages/form-builder'
import { BuilderPage } from '../pages/builder'
import { NotFoundPage } from '../pages/not-found'

export const adminRoute = () => {
  return (
    <Route
      path=""
      element={
        <PrivateRouteWrapper>
          <Outlet />
        </PrivateRouteWrapper>
      }
    >
      <Route path="forms/:formReferenceID/versions/:versionReferenceID" element={<BuilderPage />} />
      <Route element={<MainLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="forms" element={<FormBuilderPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Route>
  )
}

export const MainRouter: FC = () => {
  const router = createBrowserRouter(createRoutesFromElements(adminRoute()))
  return <RouterProvider router={router} />
}
